module.exports = __webpack_public_path__ + "img/bb_dodo_7s_chuchote.8a855591.jpg";